import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory, Link } from 'react-router'
import './tools.css'
import { isIOs, isMobile, getVideo } from '../../misc/selectors'
import { createAction } from 'redux-actions'
import { EDIT_USER, loadFile, extractFromUrl, createVideoFromFile, CREATE_TEMP_VIDEO, cancel } from '../../actions'
import { canPlayVideoFile } from '../../misc/utilities'
import VideoProgress from '../../misc/videoProgress/VideoProgress.js'

const mapStateToProps = (state, ownProps) => {
  const { videos, me, tools } = state

  return {
    isIOs: isIOs(state),
    me,
    isMobile: isMobile(state),
    tempVideo: getVideo(videos.cache, tools.tempcode), 
    action: ownProps.action
  }
}

class Tool extends Component {
  fileInput = React.createRef();
  urlInput = React.createRef();

  componentDidUpdate(prevProps, prevState) {
    if (this.props.file != prevProps.file) {
      this.gotFile(this.props.file)
    }
    if (this.props.url != prevProps.url) {
      this.gotUrl(this.props.url)
    }

    const tempVideo = this.props.tempVideo
    if (tempVideo && tempVideo.status == 2) {
      browserHistory.push(`/edit/${tempVideo.shortcode}?action=${this.props.action}`)
    }
  }

  async gotFile(file) {
    const { me, dispatch, action } = this.props

    const maxSize = me.plan_max_size
    if (maxSize && file.size > maxSize * 1073741824) {
      dispatch(createAction(EDIT_USER)({ videoExceedsLimits: `${action}-toolarge` }))
      return
    }

    const canPlay = await canPlayVideoFile(file)
    const uploadSource = 'tool-' + action
    if (canPlay) {
      dispatch(loadFile(file))
      browserHistory.push(`/clipper?upload_source=${uploadSource}&action=${action}&file=true`)
    } else {
      const data = await this.props.dispatch(createVideoFromFile(file, {
        upload_source: uploadSource,
      }))
      dispatch(createAction(CREATE_TEMP_VIDEO)(data.shortcode))
    }
  }

  gotUrl(url) {
    const uploadSource = 'tool-' + this.props.action
    browserHistory.push(`/clipper?upload_source=${uploadSource}&action=${this.props.action}&url=${url}`)
  }

  render() {
    const uploadSource = 'tool-' + this.props.action
    const {dispatch, tempVideo, action } = this.props
    const self = this
    return (
      <div className="tool">
        <form style={{ display: 'none' }}>
          <input
            id="upload-input"
            multiple={!this.props.isIOs}
            type="file"
            ref={this.fileInput}
            accept={this.props.isMobile ? "video/*" : null}
            onChange={() => {
              const files = this.fileInput.current.files
              this.gotFile(files[0])
            }}
          />
        </form>
        <div className="header">
            <div>
              <h1>Upload Video</h1>
              <p>Upload, edit and share your video in seconds.</p>
            </div>
        </div>
        {tempVideo ?
          <VideoProgress video={tempVideo} onCancel={_ => dispatch(cancel(tempVideo))} />
        : ''}
        <form
          className="form start-form"

        >
          <div className="upload-pane">
            <a
              className="upload-button"
              href="/signup"
            >Sign up now — it's free!</a>
            
          </div>
        </form>
        <div className="info-section">
          <p>This is a free tool from <Link to="/">Streamable</Link>, the video hosting service for online creatives that's loved by over 50 million users across the globe.</p>
          <p>The {action == 'trim' ? 'video trimmer' : action == 'crop' ? 'crop tool' : action == 'rotate' ? 'video rotator' : 'mute tool'} works with every file format, from MP4 video to MOV video, and is free for videos up to 10 min or 250 MB — no gimmicks and no watermarks. A <Link to="/upgrade">free trial</Link> is available for larger files.</p>
        </div>
        <div className="preview-section">
          <div className="steps">
            <h3>How to {action} your video in 3 easy steps</h3>
            <div className="step">
              <div className="stepnum">1</div>
              <div className="stepdescription">Upload your video.</div>
            </div>
            <div className="step">
              <div className="stepnum">2</div>
              <div className="stepdescription">
                {action == 'mute' ? 'Enable the "Sound Off" button.' : action == 'crop' ? 'Drag video to size.' : action == 'rotate' ? `${this.props.isMobile ? 'Tap' : 'Click'} the "Rotate" button.` : 'Drag video start and end.'}
              </div>
            </div>
            <div className="step">
              <div className="stepnum">3</div>
              <div className="stepdescription">{this.props.isMobile ? 'Tap' : 'Click'} "Create Video" and voilà!</div>
            </div>
          </div>
          <img src="https://statics.streamable.com/static/landing/editor.jpg"/>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Tool)
